import React from 'react';
import { ProjectShareForm } from './project-share-form';
import { getInvites } from '../../../api/api-projects';
import { FormattedMessage, injectIntl } from 'react-intl';

class ProjectModalShare extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: '',
      invites: []
    };
    this.getEmailInvites = this.getEmailInvites.bind(this);
    this.getEmailInvitesCb = this.getEmailInvitesCb.bind(this);
  }

  componentWillMount () {
    return this.getEmailInvites();
  }

  getEmailInvites () {
    const { accessToken, project } = this.props;
    getInvites(accessToken, project._id, this.getEmailInvitesCb);
  }

  getEmailInvitesCb (res) {
    if (res.error || res.errors || 400 < res.statusCode) {
      // Something went wrong when creating the project
      return this.setState({ errorText: this.props.intl.formatMessage({ id: 'boards.project_modal_share.error_email_invites', defaultMessage: 'Something went wrong. Please try again later.' }) });
    }
    this.setState({ invites: res.invites });
  }

  listTitle () {
    const count = this.state.invites.length;
    return (
      <ul className="list-inline">
        <li className="heavy">
          <FormattedMessage
            id="boards.project_modal_share.people_invited"
            defaultMessage="People you've invited"
          />
        </li>
        <li className="text-gray-dark">
          ({count})
        </li>
      </ul>
    );
  }

  render () {
    const { project } = this.props;
    const { errorText, invites } = this.state;
    const mappedInvites = invites.map((invite) => {
      return invite.email;
    });
    return (
      <div className="project-share-body invite-collaborators">
        <div className="text-center padding-xl-left padding-xl-right">
          <h3>
            <FormattedMessage
              id="boards.project_modal_share.invite_others"
              defaultMessage="Invite others"
            />
          </h3>
          <div>
            <div className="text-gray-dark text-large inline-block">
              <FormattedMessage
                id="boards.project_modal_share.get_help"
                defaultMessage="Get help choosing the perfect space"
              />
            </div>
          </div>
        </div>
        <hr />
        <ProjectShareForm
          {...this.props}
          sharedProject={project}
          errorText={errorText}
        />
      </div>
    );
  }
}

exports.ProjectModalShare = injectIntl(ProjectModalShare);
